const initialState = {
  items: [],
}

export default function cart (state = initialState, action) {
  switch (action.type) {
    case 'ADD_TO_CART':
      return { items: [...state.items, action.payload] }
    case 'REMOVE_FROM_CART':
      return { items: state.items.filter(item => action.payload !== item.id) }
    case 'UPDATE_IN_CART':
      let newItems = state.items.filter(item => action.payload.id !== item.id)
      newItems.push(action.payload)
      return { items: newItems }
    case 'CLEAR_CART':
      return { items: [] }
    default:
      return state
  }
}

export const getProductFromCart = (state, productId) => {
  for (let item of state.cart.items) {
    if (item.id === productId) {
      return item
    }
  }
  return null
}
